import React, { useEffect, useState } from "react";
import axios from "axios";
import ProductCard from "../components/ProductCard";
import { formatEUR } from "../lib/api";

export default function PacksPage() {
  const [packs, setPacks] = useState([]);
  useEffect(() => {
    document.title = "Packs regalo · Mimes Gourmet";
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/packs`).then((r) => setPacks(r.data));
  }, []);
  return (
    <div>
      <section className="relative py-24 bg-gradient-to-b from-[color:var(--brand-bg-alt)] to-[color:var(--brand-bg)]">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center">
          <p className="eyebrow mb-4">Regalos gourmet</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[color:var(--brand-primary)] font-light">
            Packs <span className="italic text-[color:var(--brand-terracotta)]">para mimar</span>
          </h1>
          <p className="mt-6 max-w-2xl mx-auto text-[color:var(--brand-neutral)]">
            Cajas curadas para regalar (o auto-regalarte). Presentadas en caja kraft con separadores y cinta de rafia natural.
          </p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div data-testid="packs-grid" className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {packs.map((p, i) => (
            <div key={p.id} className="relative">
              {p.savings_eur && (
                <span className="absolute -top-3 left-4 z-10 text-[10px] tracking-widest uppercase font-semibold bg-[color:var(--brand-terracotta)] text-white px-3 py-1 rounded-sm">
                  Ahorra {formatEUR(p.savings_eur)}
                </span>
              )}
              <ProductCard product={p} index={i} />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
